<template>
  <div class="message-feedback" :class="{ 'feedback-rated': currentRating !== null }">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          x-small
          icon
          aria-label="Resposta útil"
          class="action-btn"
          :class="{ 'action-btn--up': currentRating === 'up' }"
          :disabled="loading"
          @click="submit('up')"
          v-on="on"
        >
          <v-icon small>{{ currentRating === 'up' ? 'mdi-thumb-up' : 'mdi-thumb-up-outline' }}</v-icon>
        </v-btn>
      </template>
      <span>Resposta útil</span>
    </v-tooltip>

    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn
          x-small
          icon
          aria-label="Resposta não ajudou"
          class="action-btn"
          :class="{ 'action-btn--down': currentRating === 'down' }"
          :disabled="loading"
          @click="submit('down')"
          v-on="on"
        >
          <v-icon small>{{ currentRating === 'down' ? 'mdi-thumb-down' : 'mdi-thumb-down-outline' }}</v-icon>
        </v-btn>
      </template>
      <span>Resposta não ajudou</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'MessageFeedback',

  props: {
    messageId: {
      type: String,
      required: true,
    },
    initialRating: {
      type: String,
      default: null, // "up" | "down" | null
      validator: (v) => v === null || v === 'up' || v === 'down',
    },
    chatService: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      currentRating: this.initialRating,
      loading: false,
    };
  },

  methods: {
    async submit(rating) {
      if (rating !== 'up' && rating !== 'down') return;
      if (this.loading) return;

      const previous = this.currentRating;
      this.currentRating = rating; // otimista
      this.loading = true;

      try {
        await this.chatService.postMessageFeedback(this.messageId, rating);
        this.$emit('feedback-submitted', { messageId: this.messageId, rating });
      } catch (err) {
        this.currentRating = previous; // reverte
        this.$emit('feedback-error', err);
        // eslint-disable-next-line no-console
        console.warn('Falha ao registrar feedback', err);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.message-feedback {
  display: inline-flex;
  gap: 2px;
}

.action-btn {
  color: #757575 !important;
  border-radius: 6px !important;
}

.action-btn:hover {
  background-color: rgba(0, 0, 0, 0.06) !important;
}

.action-btn--up {
  color: #2e7d32 !important;
}

.action-btn--down {
  color: #c62828 !important;
}

.theme--dark .action-btn {
  color: #9e9e9e !important;
}

.theme--dark .action-btn:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.theme--dark .action-btn--up {
  color: #66bb6a !important;
}

.theme--dark .action-btn--down {
  color: #ef9a9a !important;
}
</style>
